export interface Template {
  id: string;
  label: string;
  icon: string;
  template: string; // Uses %[...] for interactive placeholders
}

export const TEMPLATES: Template[] = [
  {
    id: 'chronology',
    label: 'Build a chronology',
    icon: 'lucide--git-branch-plus',
    template:
      'Build a chronology of events relating to %[a legal issue, person, or organisation], between %[start date] and %[end date].',
  },
  {
    id: 'inconsistencies',
    label: 'Find inconsistencies',
    icon: 'lucide--shield-alert',
    template: 'Identify inconsistencies between %[statements given in 2020 and 2023].',
  },
  {
    id: 'document-draft',
    label: 'Draft a document',
    icon: 'lucide--file-plus-2',
    template: 'Draft a document detailing %[the high level issues in this Matter].',
  },
];
